// Prima attribuzione (first-touch) della registrazione: cattura le UTM con cui
// l'utente arriva la PRIMA volta e non le sovrascrive mai. Il dato viaggia:
// query URL -> localStorage (first-party) -> metadata di signUp -> trigger
// handle_new_user() -> colonne signup_* di profiles.

const STORAGE_KEY = 'uptra_first_utm';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// Riduce il referrer al SOLO origin (https://uptra.it, https://www.google.com…):
// mai path o query string. null se assente o non parsabile.
const referrerOrigin = (ref) => {
  if (!ref) return null;
  try {
    return new URL(ref).origin;
  } catch {
    return null;
  }
};

// Pathname della pagina di provenienza (es. /funzionalita), estratto dal
// referrer: è la pagina Uptra da cui è partito il click. null se non nota.
const referrerPath = (ref) => {
  if (!ref) return null;
  try {
    return new URL(ref).pathname;
  } catch {
    return null;
  }
};

// Da chiamare al bootstrap dell'app: registra il primo touch SOLO se non ne
// esiste già uno (la prima attribuzione non viene mai sovrascritta) e SOLO se
// l'URL corrente contiene almeno una UTM.
export const captureFirstTouch = () => {
  try {
    if (localStorage.getItem(STORAGE_KEY)) return; // first-touch già registrato

    const params = new URLSearchParams(window.location.search);
    const utm = {};
    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value) utm[`signup_${key}`] = value.slice(0, 200);
    }
    if (Object.keys(utm).length === 0) return; // nessuna UTM: nessun touch

    const payload = {
      ...utm,
      signup_referrer: referrerOrigin(document.referrer),
      signup_landing_path: referrerPath(document.referrer),
      utm_captured_at: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // storage pieno/bloccato o URL anomalo: l'attribuzione non deve mai
    // interferire con l'app.
  }
};

// Oggetto da includere nei metadata di signUp() alla registrazione.
// {} se non c'è alcun first-touch registrato (signup organico: colonne NULL).
export const buildUtmPayload = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};
